import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TesLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrtes`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<any> {
    return this.httpClient.get(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CF4TEXTO', divider: 'DESCRICAO', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CF4CODIGO', label: 'Código', width: '30%'},
      {property: 'CF4TEXTO', label: 'Descrição', width: '70%'},
    ];
  }

  getFieldFormater(value: any): string {
    return `${value.CF4CODIGO} - ${value.CF4TEXTO}`;
  }

}

export interface Tes {
  'CF4CODIGO': string;
  'CF4TEXTO': string;
}
